import React from "react";
import { useOutletContext } from "react-router-dom";
import LegalHtmlPage from "../components/LegalHtmlPage";

export default function EulaPage() {
  const { text } = useOutletContext();
  return <LegalHtmlPage title={text.Arabic14} htmlField="eula" />;
}
